import * as types from './types';

const INITIAL_STATE = {
  transactionTypesData: [],
  loadingTransactionTypesData: false,
  loadingTransactionTypesDataError: null,

  printLoading: false,
  printError: null,
  emptyPrintResponse: null,
  printData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.REPORT_TRANSACTION_TYPES_LOADING:
      return {
        ...state,
        loadingTransactionTypesData: action.payload,
      };

    case types.REPORT_TRANSACTION_TYPES:
      return {
        ...state,
        transactionTypesData: action.payload,
      };

    case types.REPORT_TRANSACTION_TYPES_LOADING_ERROR:
      return {
        ...state,
        loadingTransactionTypesDataError: action.payload,
      };

    case types.PRINT_REPORT_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.PRINT_REPORT_ERROR:
      return { ...state, printError: action.payload };

    case types.PRINT_REPORT_DATA:
      return { ...state, printData: action.payload };

    case types.CLEAR_PRINT_REPORT_ERROR:
      return {
        ...state,
        printError: null,
        emptyPrintResponse: null,
        loadingTransactionTypesDataError: null,
        printData: null,
      };

    case types.RESET_PRINT_RESPONSE:
      return {
        ...state,
        emptyPrintResponse: null,
      };

    case types.SET_PRINT_RESPONSE_EMPTY:
      return {
        ...state,
        emptyPrintResponse: '',
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/commonState/reducer.js